import { ref } from "vue";
import { saveAs } from "file-saver";

import { FurideKanriService } from "@/service/FurideKanriService";
import { DialogService } from "@/service/DialogService";

export function useCreate() {
  const isCreating = ref(false);

  const getFileName = (disposition: string) => {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)$/;
    const matches = filenameRegex.exec(disposition);
    // console.log(matches);
    if (matches != null && matches[1]) {
      const fileName = matches[1].replace(/('|"|utf-8)/g, "");
      return decodeURI(fileName); // 日本語対応
    } else {
      return null;
    }
  };

  // CSVダウンロード
  const downloadFurideCSV = async () => {
    isCreating.value = true;
    const srv = new FurideKanriService();
    DialogService.nowloading("CSVダウンロード中...");

    try {
      await srv.checkFurideCSV();
      const res = await srv.downloadFurideCSV();
      const mimeType = res.headers["content-type"];
      const fileName = String(getFileName(res.headers["content-disposition"]));

      // レスポンスからCSVファイルを生成
      const blob = new Blob([res.data], { type: mimeType });
      saveAs(blob, fileName);

      DialogService.info(
        {
          text: `CSVをダウンロードしました`,
        },
        true
      );
    } catch (e) {
      console.log(e);
      DialogService.error(
        {
          text: "CSVファイルの作成に失敗しました",
        },
        true
      );
    } finally {
      isCreating.value = false;
    }
  };

  return {
    isCreating,
    downloadFurideCSV,
  };
}
